import {connect} from 'react-redux';

import {getUser, makeGetDisplayName} from 'mattermost-redux/selectors/entities/users';

import {type GlobalState} from 'mattermost-redux/types/store';

import UserProfile, {type UserProfileProps} from './user_profile';

function makeMapStateToProps() {
    const getDisplayName = makeGetDisplayName();

    return (state: GlobalState, ownProps: UserProfileProps) => {
        let user;
        let displayName;

        if (ownProps.userId) {
            user = getUser(state, ownProps.userId);
            displayName = getDisplayName(state, ownProps.userId, true);
        }

        return {
            displayName,
            user,
            isShared: Boolean(user && user.remote_id),
        };
    };
}

export default connect(makeMapStateToProps)(UserProfile);
